export default __webpack_public_path__ + "static/media/box.c7528167.svg";